// src/Install.js
import { useEffect, useState } from "react";

const Install = () => {
  const [canInstall, setCanInstall] = useState(false);

  useEffect(() => {
    // Listen for the PWA install event
    const handler = (e) => {
      e.preventDefault(); // Disable automatic browser popup
      window.deferredPrompt = e; // Save the event for the button
      setCanInstall(true);
    };

    window.addEventListener("beforeinstallprompt", handler);

    // Cleanup
    return () => {
      window.removeEventListener("beforeinstallprompt", handler);
    };
  }, []);

  const installApp = async () => {
    if (!window.deferredPrompt) return;

    window.deferredPrompt.prompt();

    const choiceResult = await window.deferredPrompt.userChoice;
    console.log("User install choice:", choiceResult);

    window.deferredPrompt = null;
    setCanInstall(false); // Hide button after attempted install
  };

  // If the app is already installed → don’t show the button
  useEffect(() => {
    window.addEventListener("appinstalled", () => {
      console.log("PWA was installed");
      setCanInstall(false);
    });
  }, []);

  if (!canInstall) return null;

  return (
    <button
      onClick={installApp}
      className="button-dart"
      style={{ marginTop: "10px" }}
    >
    <p>INSTALL</p>   
    <p>APP</p>  
    </button>
  );
};

export default Install;
